module.exports = __webpack_public_path__ + "static/img/alarm_redg.351d4a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/alarm_redg.png
// module id = 8OV0
// module chunks = 2